<template>
  <!-- ================= LOADING OVERLAY ================= -->
  <div v-if="loading" class="loading-overlay">
    <md-progress-spinner
        md-mode="indeterminate"
        :md-diameter="60"
        :md-stroke="6">
    </md-progress-spinner>

    <div class="loading-text">
      Loading details...
    </div>
  </div>

  <!-- ================= ACTUAL CONTENT ================= -->
  <div v-else>
    <md-switch v-if="can('reject-accepted-voucher') && voucher.status==='Accepted'"
        v-model="voucher.force_reject"
        class="md-primary"
        @change="toggleForceReject"
    >
      {{ voucher.force_reject ? 'Force Reject: ON' : 'Force Reject: OFF' }}
    </md-switch>
    <!-- 🔽 EVERYTHING YOU ALREADY HAVE GOES HERE 🔽 -->
    <div v-cloak>

      <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-small-size-100">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-green">
                        <div class="card-icon">
                            <md-icon class="md-size-2x">money</md-icon>
                        </div>
                        <h3 class="title">Voucher <b>#<span v-html="voucher.voucher_number"></span></b></h3>
                    </md-card-header>

                    <div class="md-layout">
                        <div class="md-layout-item"><b>Voucher Number:</b><span v-text="voucher.voucher_number"></span></div>

                        <div class="md-layout-item"><b>Start Date:</b><span v-text="formatDate(voucher.start_date)"></span>
                        </div>
                      <div class="md-layout-item"><b>End Date:</b><span v-text="formatDate(voucher.end_date)"></span>
                        </div>
                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item"><b>Vendor:</b>{{getVendor()}}</div>
                        <div class="md-layout-item"><b>Accepted for Payment Date:</b><span v-text="voucher.payment_date?new Date(voucher.payment_date).toLocaleDateString():''"></span></div>
                      <div class="md-layout-item"></div>

                    </div>
                    <div class="md-layout">
                        <div class="md-layout-item"><b>Current Status: </b><span v-text="voucher.status"></span></div>
                        <div class="md-layout-item"><b>Station: </b>
                      {{getStation()}}
                        </div>
                      <div class="md-layout-item"></div>
                    </div>
                    <div class="md-layout">
                        <md-card-content>
                            <div class="md-layout-item">
                                <md-button @click="goBack" class="md-primary md-dense">
                                    Back to List
                                </md-button>

                            </div>


                        </md-card-content>


                    </div>

                </md-card>
            </div>
      </div>
<div class="md-layout">
        <div class="md-layout-item md-medium-size-100 md-small-size-100">
            <nav-tabs-card>
                <template slot="content">
                    <span class="md-nav-tabs-title">Payment Process</span>
                    <md-tabs class="md-info" md-alignment="left">

                      <md-tab id="tab-home" md-label="Utilization Sheet Summary" md-icon="view_list">

                        <!-- ===== FIXED TWO-COLUMN LAYOUT ===== -->
                        <div class="voucher-layout">

                          <!-- ================= LEFT: MAIN CONTENT ================= -->
                          <div class="voucher-content">

                            <md-card>
                              <md-card-header class="md-card-header-icon md-card-header-green">
                                <h4 class="title"><b>Summary of Utilization Sheets</b></h4>
                              </md-card-header>

                              <md-card-content>

                                <!-- ACTION BUTTONS -->
                                <div class="md-layout md-alignment-right">
                                  <md-button class="md-success md-dense md-round" @click="exportToExcel">
                                    <md-icon>grid_on</md-icon> Export Excel
                                  </md-button>

                                  <md-button class="md-info md-dense md-round" @click="exportToPDF">
                                    <md-icon>picture_as_pdf</md-icon> Preview PDF
                                  </md-button>

                                  <md-button class="md-raised md-success md-dense md-round" @click="downloadPDF">
                                    <md-icon>download</md-icon> Download PDF
                                  </md-button>
                                </div>

                                <hr />

                                <!-- PDF PREVIEW -->
                                <div v-if="pdfPreviewUrl" class="pdf-container">
                                  <md-button class="md-icon-button md-dense close-btn" @click="pdfPreviewUrl=null">
                                    <md-icon>close</md-icon>
                                  </md-button>

                                  <iframe
                                      :src="pdfPreviewUrl"
                                      style="width:100%; height:90vh; border:1px solid #ccc;">
                                  </iframe>
                                </div>

                                <!-- TABLE -->
                                <md-table>
                                  <md-table-row>
                                    <md-table-head md-numeric>SN</md-table-head>
                                    <md-table-head>Utilization Sheet No</md-table-head>
                                    <md-table-head>Sheet Date</md-table-head>
                                    <md-table-head>Service Date</md-table-head>
                                    <md-table-head>Department</md-table-head>
                                    <md-table-head>Guidance Type</md-table-head>
                                    <md-table-head md-numeric>{{getQtyUnit()}}</md-table-head>
                                    <md-table-head md-numeric>Amount</md-table-head>
                                    <md-table-head md-numeric>VAT(18%)</md-table-head>
                                    <md-table-head md-numeric>Total</md-table-head>
                                    <md-table-head>Action</md-table-head>
                                  </md-table-row>

                                  <md-table-row v-for="(item, ind) in sortedInvoices" :key="item.id">
                                    <md-table-cell md-numeric>{{ ind + 1 }}</md-table-cell>
                                    <md-table-cell>{{ item.invoice_number }}</md-table-cell>
                                    <md-table-cell>{{ formatDate(item.invoice_date) }}</md-table-cell>
                                    <md-table-cell>{{ formatDate(item.start_date) }} - {{ formatDate(item.end_date) }}</md-table-cell>
                                    <md-table-cell>{{ item.department.name }}</md-table-cell>
                                    <md-table-cell>{{ item.guidance_type }}</md-table-cell>
                                    <md-table-cell md-numeric>{{ getQty(item) }}</md-table-cell>
                                    <md-table-cell md-numeric>{{ currencyFormat(item.amount) }}</md-table-cell>
                                    <md-table-cell md-numeric>{{ currencyFormat(item.vat) }}</md-table-cell>
                                    <md-table-cell md-numeric>{{ currencyFormat(item.amount+item.vat) }}</md-table-cell>
                                    <md-table-cell>
                                      <md-button class="md-icon-button md-info" @click="goToView(item)">
                                        <md-icon>search</md-icon>
                                      </md-button>
                                    </md-table-cell>
                                  </md-table-row>
                                  <!-- ===== TOTAL ROW (FIXED) ===== -->
                                  <md-table-row class="table-total-row">
                                    <md-table-cell></md-table-cell>
                                    <md-table-cell></md-table-cell>
                                    <md-table-cell></md-table-cell>
                                    <md-table-cell>
                                      <strong>Total</strong>
                                    </md-table-cell>
                                    <md-table-cell></md-table-cell>
                                    <md-table-cell></md-table-cell>
                                    <md-table-cell md-numeric>{{totalQty(voucher)}}</md-table-cell>
                                    <md-table-cell md-numeric>
                                      <strong>{{ currencyFormat(voucher.gross_pay) }}</strong>
                                    </md-table-cell>
                                    <md-table-cell md-numeric>

                                      <strong>{{ currencyFormat(voucher.vat) }}</strong>
                                    </md-table-cell>
                                    <md-table-cell md-numeric>
                                      <strong>{{ currencyFormat(voucher.vat+voucher.gross_pay) }}</strong>
                                    </md-table-cell>
                                    <md-table-cell></md-table-cell>
                                  </md-table-row>

                                </md-table>
                                <div class="md-layout-item md-medium-size-20 md-small-size-20" v-if="can('list-voucher-signature')">
                                  <div class="md-layout">
                                  <div
                                      class="md-layout-item"
                                      v-for="status in filteredStatuses"
                                      v-if="status.name=='Approved' && status.deleted_at===null"
                                  >
                                    <b>
                                      Approved by:
                                      <br> <u><span v-html="creatorLabel(status)"></span></u><br/>
                                      Signature:
                                      <img :src="signature+status.attachment" style="width:100px"/><br/>
                                      Date: {{ new Date(status.created_at).toLocaleDateString() }}
                                    </b>
                                  </div>
                                  <div
                                      class="md-layout-item"
                                      v-for="status in filteredStatuses"
                                      v-if="status.name=='Accepted' && status.deleted_at===null"
                                  >
                                    <b>
                                      Accepted by:
                                     <br> <u><span v-html="creatorLabel(status)"></span></u><br/>
                                      Signature:
                                      <img :src="signature+status.attachment" style="width:100px"/><br/>
                                      Date: {{ new Date(status.created_at).toLocaleDateString() }}
                                    </b>
                                  </div>
                                  </div>
                                  <!-- Reviewed / Certified / Approved blocks -->
                                </div>
                                <!-- ================= ACTION BUTTONS ================= -->
                                <div class="voucher-actions">

                                  <md-button
                                      v-if="can('accept-voucher-status') && voucher.status==='Approved'"
                                      class="md-info md-round md-dense"
                                      @click="modal.classicModal = true"
                                  >
                                    Accept for Payment
                                  </md-button>

                                  <md-button
                                      v-if="can('approve-voucher-status') && !voucher.status"
                                      class="md-info md-round md-dense"
                                      @click="modal.classicModal = true"
                                  >
                                    Approve
                                  </md-button>

                                  <md-button
                                      v-if="can('reject-voucher-status') && (voucher.status !== 'Accepted' || voucher.force_reject)"
                                      class="md-danger md-round md-dense"
                                      @click="reject = true; modal.classicModal = true"
                                  >
                                    Reject
                                  </md-button>

                                </div>



                              </md-card-content>
                            </md-card>

                          </div>

                          <!-- ================= RIGHT: STATUS TIMELINE ================= -->
                          <div class="voucher-timeline" v-if="can('list-voucher-status')">

                            <md-card>
                              <md-card-header>
                                <strong>Status Timeline</strong>
                              </md-card-header>

                              <md-card-content>
                                <time-line plain type="simple">

                                  <time-line-item
                                      v-for="status in voucher.statuses_with_trashed"
                                      :key="status.id"
                                      inverted
                                      :badge-type="status.deleted_at ? 'danger' : 'info'"
                                      badge-icon="label_important_outlined"
                                  >

              <span slot="header"
                    :class="status.deleted_at ? 'badge badge-danger' : 'badge badge-info'">
                {{ status.name }}
              </span>

                                    <div slot="content">
                                      {{ status.reason }}
                                    </div>

                                    <h6 slot="footer">
                                      By:
                                      <span v-html="creatorLabel(status)"></span><br>
                                      {{ new Date(status.created_at).toLocaleString() }}
                                    </h6>

                                  </time-line-item>

                                </time-line>
                              </md-card-content>
                            </md-card>

                          </div>

                        </div>
                      </md-tab>



                    </md-tabs>
                    <modal v-if="modal.classicModal" @close="classicModalHide">
                        <template slot="header">
                            <h4 class="modal-title">Change status</h4>
                            <md-button class="md-simple md-just-icon md-round modal-default-button"
                                       @click="classicModalHide">
                                <md-icon>clear</md-icon>
                            </md-button>
                        </template>

                        <div slot="body">

                            <!--                Reject Status-->
                            <div v-if="reject">
                                <p>Please provide reason(s) for rejection
                                    Reject button</p>

                                <form @submit.prevent="update">
                                    <md-card-content>
                                        <div class="md-layout">
                                            <div class="md-layout-item">
                                                <md-field class="md-invalid">
                                                    <md-input v-model="status.reason" placeholder="Reasons for Rejection"/>
                                                    <validation-error :errors="apiValidationErrors.reason"/>
                                                </md-field>
                                            </div>
                                        </div>
                                    </md-card-content>

                                    <md-button @click="update" class="md-danger md-dense">
                                        Reject
                                    </md-button>
                                </form>
                            </div>

<!--                            <div v-if="can('accept-invoice-status')&&voucher.status==''">-->
<!--                                <p>Ensure that the Invoice is OK then write your comment for Acceptance (option) and click-->
<!--                                    Accept button</p>-->

<!--                                <form @submit.prevent="update">-->
<!--                                    <md-card-content>-->

<!--                                        <div class="md-layout">-->
<!--                                            <div class="md-layout-item">-->
<!--                                                <md-field class="md-invalid">-->
<!--                                                    <md-input v-model="status.reason" placeholder="Reason/Comment"/>-->
<!--                                                    <validation-error :errors="apiValidationErrors.reason"/>-->
<!--                                                </md-field>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </md-card-content>-->

<!--                                    <md-button @click="update" class="md-primary md-dense">-->
<!--                                        Accept-->
<!--                                    </md-button>-->
<!--                                </form>-->
<!--                            </div>-->
                            <div v-else-if="can('approve-voucher-status')&&voucher.status==''">
                                <p>Ensure that the Invoices are OK then write your comment for Approval (option) and click
                                    Approve button</p>

                                <form @submit.prevent="update">
                                    <md-card-content>

                                        <div class="md-layout">
                                            <div class="md-layout-item">
                                                <md-field class="md-invalid">
                                                    <md-input v-model="status.reason" placeholder="Reason/Comment"/>
                                                    <validation-error :errors="apiValidationErrors.reason"/>
                                                </md-field>
                                            </div>
                                        </div>
                                    </md-card-content>

                                    <md-button @click="update" class="md-primary md-dense">
                                       Approve
                                    </md-button>
                                </form>
                            </div>
                            <div v-else-if="can('accept-voucher-status')&&voucher.status==='Approved'">
                                <p>Please enter voucher number then click
                                    Accept button</p>

                                <form @submit.prevent="update">
                                    <md-card-content>

                                        <div class="md-layout">
                                            <div class="md-layout-item">
                                                <md-field class="md-invalid">
                                                    <md-input v-model="status.reason" placeholder="Reason/Comment(Option)"/>
                                                    <validation-error :errors="apiValidationErrors.reason"/>
                                                </md-field>
                                                <md-field class="md-invalid">
                                                    <md-input v-model="voucher.voucher_number" placeholder="Voucher Number (Mandatory)"/>
                                                    <validation-error :errors="apiValidationErrors.voucher_number"/>
                                                </md-field>
                                            </div>
                                        </div>
                                    </md-card-content>

                                    <md-button @click="update" class="md-primary md-dense">
                                        Accept for Payment
                                    </md-button>
                                </form>
                            </div>

                            <div v-else-if="voucher.status==='Accepted'">
                              <div class="md-layout-item" v-for="status in acceptedStatuses" :key="status.id">
                                <b>It is Accepted by: <u>{{status.creator?status.creator.name:status.creator_id}}</u><br/>
                                  Signature: <img :src="signature+status.attachment" style="width: 100px;"/><br/>
                                  Date: {{new Date(status.created_at).toLocaleDateString()}}</b>
                              </div>
                            </div>
                            <p v-else class="text-danger">You are not authorized</p>
                        </div>
                        <template slot="footer">
                            <md-button class="md-danger md-simple" @click="classicModalHide">Close</md-button>
                        </template>
                    </modal>
                </template>
            </nav-tabs-card>
        </div>
      </div>
      </div>
</div>

</template>
<script>
import formMixin from '@/mixins/form-mixin';
import _ from 'lodash';
import { TimeLine, TimeLineItem, Modal, NavTabsCard, ValidationError } from '@/components';
import Vuex from 'vuex';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import leftLogo from '@/assets/images/logo_bibi_bwana.png';
import rightLogo from '@/assets/images/TPA_Logo.png';

export default {
    components: {
        TimeLine,
        TimeLineItem,
        ValidationError,
        Modal,
        NavTabsCard
    },
    mixins: [formMixin],
    data: () => ({
        tabs: {
            selected: [],
            responsive: false,
            firstTabs: [],
            secondTabs: [],
            thirdTabs: [],
        },
      loading: true,   // 👈 IMPORTANT
      pdfPreviewUrl: null, // used to show the generated PDF
      pdfBlob: null, // store blob for downloading
        roles: [],
        statuses: [],
        allPermissions: [],
        responsive: true,// Timeline
        table: [],
        selected_contributions:[],
        query: null,

        sortation: {
            field: 'invoice_number', // default sort
            order: 'asc',
        },

        pagination: {
            perPage: 10,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
        },

        total: 0,
        items: [],
        voucherData: {},
        departments:[],
        voucher: {
            type: 'vouchers',
            voucher_number:null,
            payment_date:null,
          vat:null,
        },
        status: {
            name: null,
            reason: null,
        },

      reject:false,
        modal: {
            classicModal: false,
            updateDetailModal: false,
            addDetailModal: false,
            addWorkItemModal: false,
            updateWorkItemModal: false,
        },
        signature: null,


    }),


    created () {
        this.get();
        this.getDepartments();
        this.signature = process.env.VUE_APP_IMG_URL;
    },

    methods: {
      async toggleForceReject(value) {
        const previousValue = !value;

        try {
          const payload={
            id: this.voucher.id,
            force_reject: value,
          }
          console.log(payload);
          await this.$store.dispatch('vouchers/forceReject', payload);
          await this.$store.dispatch(
              'alerts/success',
              `Force Reject ${value ? 'enabled' : 'disabled'}.`
          );

        } catch (e) {
          // Restore switch if API fails
          this.voucher.force_reject = previousValue;

          console.error('Failed to update force reject', e);

          let message = 'Failed to update Force Reject.';

          if (e.response && e.response.data) {
            const data = e.response.data;

            if (data.errors && data.errors.length > 0) {
              message = data.errors[0].detail || message;
            } else if (data.message) {
              message = data.message;
            }
          }

          console.error('Failed to update force reject', e);
          await this.$store.dispatch(
              'alerts/error',
              message
          );
        }
      },

      totalLabourerCount(voucher) {
        return (voucher.invoices || []).reduce(
            (total, invoice) => total + (invoice.invoice_items_count || 0),
            0
        );
      },
      totalQty(voucher) {
        const units={
          MH:this.totalLabourerCount(voucher),
          PT:voucher.total_quantity,
          PU:voucher.total_quantity,
          TU:voucher.total_quantity,
        }
        return (units[this.voucher.pay_code] || 0);

      },

      getQty(item) {
        const units = {
          MH: item.invoice_items_count,
          PT:item.total_quantity,
          PU:item.total_quantity,
          TU: item.total_quantity,
        };

        return units[this.voucher.pay_code];
      },
      getQtyUnit() {
        const units = {
          MH: "Labourer Count",
          PT: "Tonnage",
          PU: "Quantity",
          TU: "TEUs",
        };

        return units[this.voucher.pay_code] || "Unknown";
      },
      getStation(){
       return  this.voucher.invoices &&
        this.voucher.invoices.length
            ? this.voucher.invoices[0].department.port.station.name
            : ''
      },
      getVendor(){
       return this.voucher.vendor?this.voucher.vendor.name:''
      },
      exportToExcel() {
        const data = this.sortedInvoices.map((item, index) => ({
          SN: index + 1,
          "Sheet Number": item.invoice_number,
          "Sheet Date": item.invoice_date,
          "Service Period": `${item.start_date} - ${item.end_date}`,
          Department: (item.department && item.department.name) || "",
          Description: item.guidance_type,
          Amount: this.currencyFormat(item.amount),
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payments Summary");

        const fileName = `Voucher_${this.voucher.voucher_number || "Summary"}.xlsx`;
        XLSX.writeFile(workbook, fileName);
      },
      formatDate(date) {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const year = d.getFullYear();
  return `${day}-${month}-${year}`; // format: DD/MM/YYYY
},
      downloadPDF() {
        if (!this.pdfBlob) return;
        const url = URL.createObjectURL(this.pdfBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Voucher_${(this.voucher && this.voucher.voucher_number) || "Summary"}.pdf`;
        link.click();
        URL.revokeObjectURL(url); // clean up
      },
      async exportToPDF() {
        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const title = "TANZANIA PORTS AUTHORITY";
        const subTitle = "LABOUR UTILIZATION SHEET SUMMARY";

        const vendor = `VENDOR: ${this.getVendor()}`;
        const station = `STATION: ${this.getStation()}`;

        const loadImage = (url) =>
            new Promise((resolve, reject) => {
              const img = new Image();
              img.crossOrigin = "Anonymous";
              img.src = url;
              img.onload = () => resolve(img);
              img.onerror = reject;
            });

        try {
          const [leftImg, rightImg] = await Promise.all([
            loadImage(leftLogo),
            loadImage(rightLogo),
          ]);

          doc.addImage(leftImg, "PNG", 14, 10, 25, 20);
          doc.addImage(rightImg, "PNG", pageWidth - 39, 10, 25, 20);
        } catch (e) {
          console.warn("Logo load failed:", e);
        }

        // ================= HEADER =================
        doc.setFont("helvetica", "bold");
        doc.setFontSize(15);
        doc.text(title, pageWidth / 2, 22, { align: "center" });

        doc.setFontSize(12);
        doc.text(subTitle, pageWidth / 2, 30, { align: "center" });

        doc.setLineWidth(0.2);
        doc.line(15, 35, pageWidth - 15, 35);

        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");
        doc.text(station, 14, 42);
        doc.text(vendor, 14, 48);

        // ================= TABLE =================
        const headers = [[
          "SN",
          "Sheet No",
          "Sheet Date",
          "Service Date",
          "Department",
          "Type",
          `${this.getQtyUnit()}`,
          "Amount",
          "VAT",
          "Total"
        ]];

        const data = this.sortedInvoices.map((item, index) => [
          index + 1,
          item.invoice_number,
          this.formatDate(item.invoice_date),
          `${this.formatDate(item.start_date)} - ${this.formatDate(item.end_date)}`,
          item.department?.name || "",
          item.guidance_type,
          `${this.getQty(item)}`,
          this.currencyFormat(item.amount),
          this.currencyFormat(item.vat),
          this.currencyFormat(item.amount + item.vat),
        ]);

        const subtotalRowIndex = data.length;

        data.push([
          "", "", "", "",
          "TOTAL",
          "",
          this.totalQty(this.voucher),
          this.currencyFormat(this.voucher.gross_pay),
          this.currencyFormat(this.voucher.vat),
          this.currencyFormat(this.voucher.gross_pay + this.voucher.vat),
        ]);

        doc.autoTable({
          startY: 55,
          head: headers,
          body: data,
          theme: "grid",
          styles: { fontSize: 8 },
          headStyles: { fillColor: [46, 125, 50] },
          didParseCell: (data) => {
            if (data.row.index === subtotalRowIndex) {
              data.cell.styles.fontStyle = "bold";
            }
          },
        });

        const tableEndY = doc.lastAutoTable.finalY;

        // ================= SIGNATURES =================
        if (this.can("list-voucher-signature")) {
          const statuses = this.filteredStatuses || this.voucher.statuses_with_trashed || [];
          const baseUrl = this.signature || "";

          const signatureMap = ["Approved", "Accepted"];
          const filtered = signatureMap.map(label =>
              statuses.find(s => s.name === label && !s.deleted_at)
          );

          const sigStartY = tableEndY + 20;
          const colWidth = (pageWidth - 30) / signatureMap.length;

          doc.setFontSize(9);

          filtered.forEach((status, i) => {
            const x = 15 + i * colWidth;

            doc.text(`${signatureMap[i]} By:`, x, sigStartY);

            const creator = this.creatorLabelPdf(status);
            if (creator) {
              doc.text(creator, x, sigStartY + 6);
            }

            doc.setLineDash([0.5, 1], 0);
            doc.line(x, sigStartY + 18, x + 45, sigStartY + 18);
            doc.setLineDash([]);

            if (status?.attachment) {
              loadImage(baseUrl + status.attachment)
                  .then(img => {
                    doc.addImage(img, "PNG", x, sigStartY + 10, 25, 10);
                  })
                  .catch(() => {
                  });
            }

            const date = status?.created_at
                ? new Date(status.created_at).toLocaleDateString()
                : "";

            doc.text(`Date: ${date}`, x, sigStartY + 28);
          });
        }
        // ================= FOOTER =================
        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);

          doc.setFontSize(8);
          doc.setTextColor(120);

          doc.text(
              `Page ${i} of ${totalPages}`,
              pageWidth / 2,
              pageHeight - 10,
              { align: "center" }
          );

          doc.text("© CLMS", pageWidth - 14, pageHeight - 10, { align: "right" });
        }

        doc.setPage(1);
        doc.text(
            `Generated on ${new Date().toLocaleString()}`,
            14,
            pageHeight - 10
        );

        // ================= OUTPUT =================
        const pdfBlob = doc.output("blob");
        this.pdfBlob = pdfBlob;
        this.pdfPreviewUrl = URL.createObjectURL(pdfBlob);
      },

      changeSort (field) {
            if (this.sortation.field === field) {
                // toggle asc/desc
                this.sortation.order = this.sortation.order === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortation.field = field;
                this.sortation.order = 'asc';
            }
        },
        goToView (item) {
          let id=item.id
          if(item.guidance_type==='Per Man Hour') {
            this.$router.push({name: 'View Utilization Sheet', params: {id}});
          }else{
            this.$router.push({name: 'View Work Utilization Sheet', params: {id}});
          }
           // this.$router.push({ name: 'View Utilization Sheet', params: { id } });
        },
      currencyFormat(amount) {
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'decimal',
          maximumFractionDigits: 2,
          minimumFractionDigits: 2
        });

        return formatter.format(amount || 0);
      },
        invoiceTypes (type) {
            const filtered = this.items.filter(s => s.guidance_type == type);
            if (filtered.length > 0) {
                return filtered;
            } else {
                return [];
            }
        },
        classicModalHide: function () {
            this.modal.classicModal = false;
            this.reject = false;
        },
        updateDetailModalHide: function () {
            this.modal.updateDetailModal = false;
        },

        async update () {
            try {
                this.voucherData = {
                    type: 'vouchers',
                    id: this.voucher.id,
                    voucher_number:this.voucher.voucher_number,
                    status: { name: this.status.name, reason: this.status.reason,reject:this.reject },
                };
                await this.$store.dispatch('vouchers/update1', this.voucherData);
                await this.$store.dispatch(
                    'alerts/success',
                    'Voucher updated successfully.'
                );
                // this.get();
                this.$router.go();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!1'
                    );
                }
            }
        },

        onResponsiveInverted () {
            if (window.innerWidth < 768) {
                this.responsive = false;
            } else {
                this.responsive = false;
            }
        },
        getListDebounced: _.debounce(function () {
            this.get();
        }, 300),

        async get () {
          this.loading = true
            try {

              await this.$store.dispatch('vouchers/get',
                this.$route.params.id
              );
                this.voucher = this.$store.getters['vouchers/voucher'];
                this.statuses = this.voucher.statuses;
                this.items = this.voucher.invoices;
                this.tabs.firstTabs = this.voucher.invoices;

                this.selected_contributions = this.voucher.invoices[0].distributions.filter(s => s.is_hidden == false);
                const v = this.voucher.invoices;
                const departments = [...new Set(v.map(item => item.department))];

                this.departments = departments;
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!2'
                );
            }finally {
              setTimeout(() => {
                this.loading = false
              }, 300)
            }
        },

        getDepartments () {
            this.$store.dispatch('departments/list').then(() => {
                this.available_departments = this.$store.getters['departments/dropdown'];
            });
        },
        goBack () {
            this.$router.push({ name: 'List Utilization Sheet Summary' });
        },

        customSort () {
            return false;
        },


      creatorLabel(status) {
        if (!status) return ''

        const creator = status.creator

        // No creator object at all
        if (!creator) {
          return status.creator_id ?? ''
        }

        const model = creator.model

        if (model) {
          const firstName = typeof model.first_name === 'string'
              ? model.first_name.trim()
              : ''

          const lastName = typeof model.last_name === 'string'
              ? model.last_name.trim()
              : ''

          const checkNo = model.check_no
              ? `<br>(C/N: ${model.check_no})`
              : ''

          const fullName = [firstName, lastName].filter(Boolean).join(' ')

          //  All safe fallbacks
          if (fullName) {
            return `${fullName}${checkNo}`
          }

          if (checkNo) {
            return `Unknown User${checkNo}`
          }

          return creator.name || 'Unknown User'
        }

        // Creator exists but no model
        return creator.name || 'Unknown User'
      },
      creatorLabelPdf(status) {
        if (!status) return ''

        const creator = status.creator

        // No creator object at all
        if (!creator) {
          return status.creator_id ?? ''
        }

        const model = creator.model

        if (model) {
          const firstName = typeof model.first_name === 'string'
              ? model.first_name.trim()
              : ''

          const lastName = typeof model.last_name === 'string'
              ? model.last_name.trim()
              : ''

          const checkNo = model.check_no
              ? `\n(C/N: ${model.check_no})`
              : ''

          const fullName = [firstName, lastName].filter(Boolean).join(' ')

          //  All safe fallbacks
          if (fullName) {
            return `${fullName}${checkNo}`
          }

          if (checkNo) {
            return `Unknown User${checkNo}`
          }

          return creator.name || 'Unknown User'
        }

        // Creator exists but no model
        return creator.name || 'Unknown User'
      },


    },

    computed: {
      sortedInvoices () {
        const invoices = this.voucher.invoices || [];
        return [...invoices].sort((a, b) => {
          const field = this.sortation.field;
          const order = this.sortation.order === 'asc' ? 1 : -1;

          const getValue = (obj, path) => path.split('.').reduce((o, key) => (o ? o[key] : null), obj);

          const valA = getValue(a, field);
          const valB = getValue(b, field);

          if (valA == null) return 1 * order;
          if (valB == null) return -1 * order;

          if (typeof valA === 'number' && typeof valB === 'number') {
            return (valA - valB) * order;
          }

          return String(valA).localeCompare(String(valB)) * order;
        });
      },

        ...Vuex.mapState({
            me: state => state.profile.me
        }),
        simpleTimeline () {
            if (this.responsive) {
                return 'simple';
            }
            return '';
        },
        sort () {
            if (this.sortation.order === 'desc') {
                return `-${this.sortation.field}`;
            }
            return this.sortation.field;
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },

        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },

        filteredStatuses () {
            return this.statuses
                .filter(s => new Date(s.created_at) <= new Date())
                .sort((a, b) => new Date(a.created_at) - new Date(b.created_at)
                );
        },
      acceptedStatuses() {
        return this.filteredStatuses.filter(
            status => status.name === 'Accepted' && status.deleted_at === null
        );
      },
        totalAmount () {
            return this.items.reduce((total_amount, item) => item.amount + total_amount  ,0);
        },
        totalTaxable () {
            return this.items.reduce((total_taxable, item) => item.total_taxable + total_taxable  ,0);
        },
        // totalVat () {
        //     return this.items.reduce((total_vat, item) => item.vat + total_vat  ,0);
        // },

    },
    watch: {
        query: {
            handler: 'getListDebounced',
            immediate: true,
        },
        // sortation: {
        //     handler: "getList",
        //     immediate: false,
        //     deep: true,
        // },
        pagination: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
    },

    mounted () {
        this.onResponsiveInverted();
        window.addEventListener('resize', this.onResponsiveInverted);
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.onResponsiveInverted);
    }

};

</script>

<style lang="scss" scoped>

    .seperator h5 {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 1em;
    }

    .seperator h5::before,
    .seperator h5::after {
        content: "";
        display: block;
        flex-grow: 1;
        height: 1px;
        background: #ccc;
    }

    .seperator h5 span {
        padding: 0 2em;
    }

    .text-center {
        text-align: center;
    }

    .places-buttons + div .md-button:not(:last-child) {
        margin-right: 1px;
    }

    .modal-container {
        max-width: 1000px !important;
    }
    .pdf-preview-container {
      position: relative;
      margin-top: 20px;
    }

    .close-btn {
      position: absolute;
      top: 15px;
      right: 20px;
      background: #f44336!important;
      color: white;
      border-radius: 50%;
      z-index: 10;
    }

    .close-btn:hover {
      background: #d32f2f;
    }
    .voucher-layout {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 16px;
    }

    /* LEFT CONTENT */
    .voucher-content {
      flex: 1;
      min-width: 0;
    }

    /* RIGHT TIMELINE */
    .voucher-timeline {
      width: 220px;
      min-width: 220px;
      position: sticky;
      top: 16px;
    }
    .voucher-actions {
      margin-top: 16px;
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }
    .loading-overlay {
      position: fixed;
      inset: 0;
      background: rgba(255, 255, 255, 0.9);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 99999;
    }

    .loading-text {
      margin-top: 12px;
      font-size: 14px;
      color: #555;
    }
    .table-total-row {
      background: #f5f7fa;
      font-weight: bold;
    }

</style>
